import { gql } from '@apollo/client';

export const GET_MESSAGE_THREAD = gql`
  query MessageThread($id: ID!) {
    messageThread(id: $id) {
      id
      subject
      tool {
        id
        name
        primaryImageUrl
      }
      participants {
        id
        name
        avatarImageUrl
        isOnline
        lastActiveAt
      }
      messages {
        id
        content
        sentAt
        deliveredAt
        receiverReadAt
        attachments {
          id
          url
          filename
          contentType
        }
        sender {
          id
          name
        }
      }
      unreadMessageCount
      createdAt
      updatedAt
    }
  }
`;
